export var JobillaCompanyIntegrations = [
    {
        id: 'workday',
        label: 'Workday',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/workday/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/workday/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/workday/icon-black.svg',
        },
    },
    {
        id: 'successfactors',
        label: 'SAP SuccessFactors',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/successfactors/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/successfactors/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/successfactors/icon-black.svg',
        },
    },
    {
        id: 'smartrecruiters',
        label: 'SmartRecruiters',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/smartrecruiters/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/smartrecruiters/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/smartrecruiters/icon-black.svg',
        },
    },
    {
        id: 'lever',
        label: 'Lever',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/lever/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/lever/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/lever/icon-black.svg',
        },
    },
    {
        id: 'recruitee',
        label: 'Recruitee',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/recruitee/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/recruitee/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/recruitee/icon-black.svg',
        },
    },
    {
        id: 'greenhouse',
        label: 'Greenhouse',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/greenhouse/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/greenhouse/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/greenhouse/icon-black.svg',
        },
    },
    {
        id: 'teamtailor',
        label: 'Teamtailor',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/teamtailor/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/teamtailor/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/teamtailor/icon-black.svg',
        },
    },
    {
        id: 'ashby',
        label: 'Ashby',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/ashby/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/ashby/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/ashby/icon-black.svg',
        },
    },
    {
        id: 'onlyfy',
        label: 'Onlyfy',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/onlyfy/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/onlyfy/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/onlyfy/icon-black.svg',
        },
    },
    {
        id: 'personio',
        label: 'Personio',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/personio/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/personio/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/personio/icon-black.svg',
        },
    },
    {
        id: 'rexx',
        label: 'rexx systems',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/rexx/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/rexx/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/rexx/icon-black.svg',
        },
    },
    {
        id: 'afas',
        label: 'AFAS Software',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/afas/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/afas/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/afas/icon-black.svg',
        },
    },
    {
        id: 'bamboohr',
        label: 'BambooHR',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/bamboohr/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/bamboohr/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/bamboohr/icon-black.svg',
        },
    },
    {
        id: 'bullhorn',
        label: 'Bullhorn',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/bullhorn/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/bullhorn/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/bullhorn/icon-black.svg',
        },
    },
    {
        id: 'workable',
        label: 'Workable',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/workable/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/workable/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/workable/icon-black.svg',
        },
    },
    {
        id: 'jobvite',
        label: 'Jobvite',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/jobvite/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/jobvite/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/jobvite/icon-black.svg',
        },
    },
    {
        id: 'softgarden',
        label: 'Softgarden',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/softgarden/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/softgarden/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/softgarden/icon-black.svg',
        },
    },
    {
        id: 'pinpoint',
        label: 'Pinpoint',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/pinpoint/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/pinpoint/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/pinpoint/icon-black.svg',
        },
    },
    {
        id: 'welcometothejungle',
        label: 'Welcome to the Jungle',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/welcometothejungle/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/welcometothejungle/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/welcometothejungle/icon-black.svg',
        },
    },
    {
        id: 'dvinci',
        label: 'd.vinci',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/dvinci/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/dvinci/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/dvinci/icon-black.svg',
        },
    },
    {
        id: 'join',
        label: 'JOIN',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/join/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/join/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/join/icon-black.svg',
        },
    },
    {
        id: 'sagehr',
        label: 'Sage HR',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/sagehr/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/sagehr/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/sagehr/icon-black.svg',
        },
    },
    {
        id: 'traffit',
        label: 'TRAFFIT',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/traffit/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/traffit/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/traffit/icon-black.svg',
        },
    },
    {
        id: 'erecruiter',
        label: 'eRecruiter',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/erecruiter/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/erecruiter/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/erecruiter/icon-black.svg',
        },
    },
    {
        id: 'umantis',
        label: 'Haufe Umantis',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/umantis/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/umantis/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/umantis/icon-black.svg',
        },
    },
    {
        id: 'taleez',
        label: 'Taleez',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/taleez/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/taleez/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/taleez/icon-black.svg',
        },
    },
    {
        id: 'hrworks',
        label: 'HRworks',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/hrworks/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/hrworks/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/hrworks/icon-black.svg',
        },
    },
    {
        id: 'otys',
        label: 'OTYS',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/otys/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/otys/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/otys/icon-black.svg',
        },
    },
    {
        id: 'eploy',
        label: 'Eploy',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/eploy/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/eploy/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/eploy/icon-black.svg',
        },
    },
    {
        id: 'heyrecruit',
        label: 'Heyrecruit',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/heyrecruit/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/heyrecruit/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/heyrecruit/icon-black.svg',
        },
    },
    {
        id: 'recruhr',
        label: 'RECRU',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/recruhr/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/recruhr/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/recruhr/icon-black.svg',
        },
    },
    {
        id: 'jazzhr',
        label: 'JazzHR',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/jazzhr/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/jazzhr/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/jazzhr/icon-black.svg',
        },
    },
    {
        id: 'bite',
        label: 'BITE',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/bite/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/bite/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/bite/icon-black.svg',
        },
    },
    {
        id: 'homerun',
        label: 'Homerun',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/homerun/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/homerun/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/homerun/icon-black.svg',
        },
    },
    {
        id: 'carerix',
        label: 'Carerix',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/carerix/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/carerix/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/carerix/icon-black.svg',
        },
    },
    {
        id: 'inrecruiting',
        label: 'InRecruiting',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/inrecruiting/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/inrecruiting/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/inrecruiting/icon-black.svg',
        },
    },
    {
        id: 'ubeeo',
        label: 'Ubeeo',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/ubeeo/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/ubeeo/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/ubeeo/icon-black.svg',
        },
    },
    {
        id: 'breezyhr',
        label: 'Breezy HR',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/breezyhr/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/breezyhr/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/breezyhr/icon-black.svg',
        },
    },
    {
        id: 'flatchr',
        label: 'Flatchr',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/flatchr/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/flatchr/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/flatchr/icon-black.svg',
        },
    },
    {
        id: 'talentadore',
        label: 'TalentAdore',
        assets: {
            logo_url: 'https://storage.googleapis.com/kombo-assets/integrations/talentadore/logo.svg',
            icon_url: 'https://storage.googleapis.com/kombo-assets/integrations/talentadore/icon.svg',
            icon_black_url: 'https://storage.googleapis.com/kombo-assets/integrations/talentadore/icon-black.svg',
        },
    },
];
